export const toastMessage = {

  statusChange: (orderId, status) => `The Order #${orderId} Status was Changed to ${status}`,

  booking: (meetingRoom, meetingTime) =>
    `You have book Meeting room "${meetingRoom}" on time ${meetingTime}`,

  invited: (meetingRoom, meetingTime) =>
    `You have been invited to "${meetingRoom}" Meeting on time ${meetingTime}`,

  extendMeeting: name => `Meeting "${name}" Meeting Time has Extended!`,

  nearStart: (name, time) => `Meeting "${name}" is about to Start in ${time} Minutes!`,

  nearEnd: (name, time) => `Meeting "${name}" is about to End in ${time} Minutes!`,

  acceptMeeting: name => `Meeting "${name}" \nAttendee has Accept your Invite.`,

  declinedMeeting: name => `Meeting "${name}" \nAttendee has Decline your Invite.`,
}

export const TOAST_MESSAGE = {
  COPY: {
    TH: 'คัดลอกลิ้งค์เรียบร้อยแล้ว',
    EN: 'Link copied'
  }
}
